import {
  IconDown,
  IconLoader,
  IconTrash,
  IconUp,
  SelectSize,
  Textarea,
  Checkbox,
  InputText,
  InputSize,
  Autocomplete,
} from '@ui/src';
import { NewApplicationStatus } from '../../../../hoc/new-application/types';
import InfoRow from '../../common/info-row';
import useCRSAndFatca from '../hooks/use-crs-and-fatca';
import { CRSAndFatcaTypes } from './types';

import commonStyles from '../../common/styles.module.css';
import cn from '../styles.module.css';

const CRSAndFatca = ({
  status,
  isEditable,
  deleteCrsAndFatcaInProgress,
  onDeleteCRSAndFatca,
  selectedCrsAndFatcaId,
  crsAndFatca,
  setCrsAndFatcaValues,
  crsAndFatcaValues,
  index,
  countries,
}: CRSAndFatcaTypes) => {
  const {
    expanded,
    setExpanded,
    onChangeHaveTin,
    onChange,
    haveTin,
    formValues,
  } = useCRSAndFatca({
    crsAndFatcaValues,
    setCrsAndFatcaValues,
    crsAndFatca,
  });

  return (
    <div
      className={`${commonStyles.accountCurrencyWrapper} ${!expanded ? commonStyles.collapsed : ''}`}
    >
      <div
        className={`${commonStyles.accountCurrencyTopWrapper} ${!expanded ? commonStyles.collapsed : ''}`}
      >
        <div className={commonStyles.accountCurrencyTop}>
          <button
            type="button"
            className={commonStyles.accountCurrencyTopLeft}
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? (
              <IconUp width={14} height={14} />
            ) : (
              <IconDown height={14} width={14} />
            )}
            {`Tax residence #${index + 1}`}
          </button>
          {isEditable &&
            status !== NewApplicationStatus.ACCEPTED &&
            status !== NewApplicationStatus.DECLINED && (
              <button
                type="button"
                className={commonStyles.deleteAccountCurrencyButton}
                onClick={() => onDeleteCRSAndFatca(crsAndFatca?.id as string)}
              >
                {deleteCrsAndFatcaInProgress &&
                selectedCrsAndFatcaId === crsAndFatca?.id ? (
                  <IconLoader width={18} height={18} />
                ) : (
                  <IconTrash />
                )}
              </button>
            )}
        </div>
      </div>
      {expanded && (
        <>
          <InfoRow title="Country" lessPadding>
            <Autocomplete
              name={`residenceCountryId-${crsAndFatca?.id}`}
              placeholder="Select country..."
              list={countries}
              value={formValues?.residenceCountryId}
              size={SelectSize.SMALL}
              onChange={(e) =>
                onChange({
                  target: {
                    name: `residenceCountryId-${crsAndFatca?.id}`,
                    value: e.target.value as string,
                  },
                })
              }
              selectWrapperClassName={
                status === NewApplicationStatus.ACCEPTED ||
                status === NewApplicationStatus.DECLINED
                  ? commonStyles.selectDisabled
                  : ''
              }
              disabled={
                !isEditable ||
                Boolean(
                  status === NewApplicationStatus.ACCEPTED ||
                  status === NewApplicationStatus.DECLINED,
                )
              }
              tabIndex={
                !isEditable &&
                Boolean(
                  status === NewApplicationStatus.ACCEPTED ||
                  status === NewApplicationStatus.DECLINED,
                )
                  ? -1
                  : 0
              }
              borderless
              fullWidth
            />
          </InfoRow>
          <div className={cn.tinCheckboxWrapper}>
            <Checkbox
              name={`haveTin-${crsAndFatca?.id}`}
              type="checkbox"
              checked={haveTin}
              onChange={(e) => onChangeHaveTin(e.target.checked)}
              title="Having a TIN"
              disabled={
                !isEditable ||
                Boolean(
                  status === NewApplicationStatus.ACCEPTED ||
                  status === NewApplicationStatus.DECLINED,
                )
              }
              tabIndex={
                !isEditable &&
                Boolean(
                  status === NewApplicationStatus.ACCEPTED ||
                  status === NewApplicationStatus.DECLINED,
                )
                  ? -1
                  : 0
              }
              labelClassName={cn.addressCheckbox}
            />
          </div>
          {haveTin && (
            <InfoRow title="TIN" lessPadding>
              <InputText
                name={`taxIdentificationNumber-${crsAndFatca?.id}`}
                placeholder="Select TIN..."
                value={formValues?.taxIdentificationNumber}
                size={InputSize.SMALL}
                onChange={(e) => {
                  onChange({
                    target: {
                      name: `taxIdentificationNumber-${crsAndFatca?.id}`,
                      value: e.target.value,
                    },
                  });
                }}
                disabled={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                }
                tabIndex={
                  !isEditable &&
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                    ? -1
                    : 0
                }
                className="borderless"
              />
            </InfoRow>
          )}
          {!haveTin && (
            <InfoRow
              title="Reason for no TIN"
              className={commonStyles.noFlex}
              lessPadding
            >
              <Textarea
                name={`noTinReason-${crsAndFatca?.id}`}
                placeholder="Enter description..."
                value={formValues?.noTinReason}
                onChange={(e) => {
                  onChange({
                    target: {
                      name: `noTinReason-${crsAndFatca?.id}`,
                      value: e.target.value,
                    },
                  });
                }}
                className={`borderless ${commonStyles.pepTextarea} ${commonStyles.stepOneTextarea}`}
                tabIndex={
                  !isEditable &&
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                    ? -1
                    : 0
                }
                disabled={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                }
              />
            </InfoRow>
          )}
        </>
      )}
    </div>
  );
};

export default CRSAndFatca;
